import React, { Component } from 'react';
import config from './../config';

class AppMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            menuContent: null,
            currentPage: -1,
            darkMode: false
        };
    }

    componentDidMount() {
        const savedTheme = localStorage.getItem('theme');
        const mediaQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

        const prefersDark = savedTheme ? savedTheme === 'dark' : (mediaQuery && mediaQuery.matches);

        if (prefersDark) {
            document.body.classList.add('dark-mode');
            this.setState({ darkMode: true });
        }

        if (!savedTheme && mediaQuery) {
            this.handleSystemThemeChange = (e) => {
                if (!localStorage.getItem('theme')) {
                    const isDark = e.matches;
                    document.body.classList.toggle('dark-mode', isDark);
                    this.setState({ darkMode: isDark });
                }
            };

            mediaQuery.addEventListener('change', this.handleSystemThemeChange);
        }
    }

    componentWillUnmount() {
        const mediaQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
        if (mediaQuery && this.handleSystemThemeChange) {
            mediaQuery.removeEventListener('change', this.handleSystemThemeChange);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.menuOpen && !this.state.menuContent && !prevProps.menuOpen) {
            this.fetchMenuContent();
        }
    }

    fetchMenuContent() {
        fetch(config.pageUrl + 'menu_' + window.currentLang + '_v2-2.json')
            .then(res => res.json())
            .then(json => this.setState({ menuContent: json.results }));
    }

    toggleDarkMode = (event) => {
        event.preventDefault();
        const nextMode = !this.state.darkMode;

        this.setState({ darkMode: nextMode }, () => {
            document.body.classList.toggle('dark-mode', nextMode);
            localStorage.setItem('theme', nextMode ? 'dark' : 'light');
        });
    }

    render() {
        return (
            <div className={'menu-wrapper' + (this.state.currentPage > -1 ? ' main-visible' : '')} ref="menuContent">
                <div className="menu-content links">
                    <p>
                        {[
                            { lang: 'is', name: 'Íslenska' },
                            { lang: 'en', name: 'English' }
                        ].map((lang, index) => (
                            <span key={lang.lang}>
                                {index > 0 && <React.Fragment> | </React.Fragment>}
                                <a 
                                    href="#" 
                                    className="lang-button" 
                                    onClick={event => {
                                        event.preventDefault();
                                        window.Lang.setCurrentLang(lang.lang);
                                        this.fetchMenuContent();
                                    }}
                                >
                                    <strong>{lang.name}</strong>
                                </a>
                            </span>
                        ))}
                        <span> | </span>
                        <a href="#" className="dark-mode-toggle" onClick={this.toggleDarkMode}>
                            <strong>
							{localStorage.getItem('currentLang') === 'en'
								? (this.state.darkMode ? '☼ Light mode' : '☾ Dark mode')
								: (this.state.darkMode ? '☼ Daghamur' : '☾ Nátthamur')}
							</strong>
                        </a>
                    </p>
                    <div className="menu-links">
                        {
                            this.state.menuContent &&
                            this.state.menuContent.map((item, index) => (
                                <a 
                                    className="menu-link" 
                                    key={index} 
                                    onClick={() => this.setState({ currentPage: index })}
                                >
                                    {item.titill}
                                </a>
                            ))
                        }
                    </div>
                </div>
                <div className="menu-content main">
                    <a 
                        className="menu-link" 
                        onClick={() => this.setState({ currentPage: -1 })}
                    >
                        <img className="menu-link-back-arrow" alt="Go back" src="/img/back-icon.png" />
                        {window.l('menu_back')}
                    </a>

                    {
                        this.state.currentPage > -1 && this.state.menuContent &&
                        <React.Fragment>
                            <h3>{this.state.menuContent[this.state.currentPage].titill}</h3>
                            <div dangerouslySetInnerHTML={{ __html: this.state.menuContent[this.state.currentPage].efni }} />
                        </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}

export default AppMenu;


// WEBPACK FOOTER //
// ./src/components/AppMenu.js